import type { PlatformActionError } from '../models/platformActionError'
import { camelKey } from '../service/actionLabels'

import { useI18n } from '@/shared/i18n'

export interface UseErrorMessage {
  errorMessage: (error: PlatformActionError) => string
}

/**
 * One place that turns a classified error into copy, so the modal, the drawer and the page all
 * say the same thing for the same code.
 *
 * The `te` guard is what keeps this honest against a backend that adds a code after this build:
 * an unmapped code falls back to `UNKNOWN`, which interpolates the envelope's own message rather
 * than rendering a raw key at the user.
 */
export function useErrorMessage(): UseErrorMessage {
  const { t, te } = useI18n()

  return {
    errorMessage: (error) => {
      const key = `platformActions.errors.${camelKey(error.code)}`
      if (te(key)) return t(key)
      return t('platformActions.errors.unknown', { detail: error.detail })
    },
  }
}
